import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { ResourceDetailsCardElement } from 'components/ResourceCardElements';
import styles from './styles';

const UserDetailsElement = ({ children, className, ...props }) =>
  <ResourceDetailsCardElement className={cx(styles.element, className)} {...props}>
    {children}
  </ResourceDetailsCardElement>;

UserDetailsElement.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default UserDetailsElement;



// WEBPACK FOOTER //
// ./client/app/shared/components/users/UserDetailsElement/index.jsx